import React from "react";
import { Alert } from "@material-ui/lab";

const ValidationErrors = ({ errors = [] }) => {
	return (
		<ul
			role="status"
			aria-live="polite"
			style={{ listStyleType: "none", padding: 0 }}
		>
			{errors.map(({ type, message }) => (
				<li key={message}>
					<Alert severity={type}>{message}</Alert>
				</li>
			))}
		</ul>
	);
};

export default ValidationErrors;
